/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Tabs, Card, Button, Form, Spin } from "antd";
import CheckIcon from "@untitled-ui/icons-react/build/esm/Check";
import getGlListAction, { rightAction } from "../../../redux/actions";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import dayjs from "dayjs";

// tabs
import ProductInformationContent from "./components/tabs/ProductInformationContent";
import TermsContent from "./components/tabs/TermsContent";
import InterestContent from "./components/tabs/InterestContent";
import AccountingContent from "./components/tabs/AccountingContent";
import CounterpartySettingsContent from "./components/tabs/CounterPartySettingsContent";
import ComplianceContent from "./components/tabs/ComplianceContent";

import { apiConfig, labelConfig, staticConfig } from "../treasury.config";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import FeedbackModal from "./components/FeedbackModal";
import Preview from "./components/tabs/Preview";

export const defaultValues = {
  //Product Information
  productCode: "",
  productName: "",
  productCategory: undefined,
  currencyCode: undefined,
  applicableEntities: undefined,
  startDate: null,
  endDate: null,

  minTenor: "",
  maxTenor: "",
  defaultTenor: "",
  allowRollover: false,
  autoRollover: undefined,
  backDatedValueDateAllowed: false,
  allowEarlyTermination: false,
  // earlyTerminationSelection: undefined,
  earlyTerminationWithPenalty: true,
  maturityDateAdjustment: undefined,
  allowPlacementFee: false,
  placementFeeWithPenalty: undefined,

  //Interest Configuration
  interestType: undefined,
  interestRateType: undefined,
  defaultRate: "",
  interestCalculationBasis: undefined,
  interestPostingType: undefined,
  allowTax: false,
  taxGroup: undefined,

  //Accounting Configuration
  placementInitiationDebit: undefined,
  placementInitiationCredit: undefined,
  interestAccrualDebit: undefined,
  interestAccrualCredit: undefined,
  interestSettlementDebit: undefined,
  interestSettlementCredit: undefined,
  principalRedemptionDebit: undefined,
  principalRedemptionCredit: undefined,
  interestGLPostingDebit: undefined,
  interestGLPostingCredit: undefined,

  //Counterparty Settings
  counterpartyTypes: undefined,
  kycRequirements: undefined,
  activateDealConfirmation: false,
  allowSwiftCode: true,
  allowRTGS: false,

  //Compliance Settings
  centralBankReports: undefined,
  riskLimit: "",
  mandatoryAMLScreening: false,
};

const TabLabel = ({ number, label, isLast, activeTab, isCompleted }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      position: "relative",
    }}
  >
    <div
      style={{
        width: "28px",
        height: "28px",
        borderRadius: "8px",
        background: isCompleted
          ? "#ECFDF3"
          : activeTab === number
          ? "#FDF4FF"
          : "#F9FAFB",
        border: isCompleted
          ? "1px solid #ABEFC6"
          : activeTab === number
          ? "1px solid #F6D0FE "
          : "1px solid #EAECF0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: activeTab === number ? "#9F1AB1" : "#344054",
        fontSize: "14px",
        fontWeight: "600",
        marginRight: "12px",
        zIndex: 10,
      }}
    >
      {isCompleted ? <CheckIcon width={12} height={12} /> : number}
    </div>
    <span
      style={{
        color: activeTab === number ? "#9F1AB1" : "#344054",
        fontWeight: "600",
        userSelect: "none",
        pointerEvents: "none",
      }}
    >
      {label}
    </span>
    {!isLast && (
      <div
        style={{
          position: "absolute",
          left: "14px",
          top: "28px",
          width: "1px",
          height: "90px",
          background: "#E5E7EB",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />
    )}
  </div>
);

const EditInterBankPlacement = ({ userData }) => {
  const navigate = useNavigate();
  const { session } = userData;
  const { state: selectedInterBankPlacementKey } = useLocation();

  const [activeTab, setActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isUpdatingProduct, setIsUpdatingProduct] = useState(false);
  const [form] = Form.useForm();
  const [interBankPlacementDetails, setInterBankPlacementDetails] =
    useState(null);
  const [currency, setCurrency] = useState(null);
  const [interbankTemplate, setInterbankTemplate] = useState(null);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [isCreateButton, setIsCreateButton] = useState(false);

  const getInterbankTemplate = () => {
    setLoading(true);
    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.InterBankPlacementTemplate,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setLoading(false);
        } else {
          setInterbankTemplate(res);
          const objList = res;
          let tempInterestTypes = [];
          let tempAssetGlAccounts = [];
          let tempIncomeGlAccounts = [];
          let tempProductCategory = [];

          const filteredInterestTypes = objList.interestTypes.filter(
            (items) =>
              items.text === "Simple Interest" ||
              items.text === "Compound Interest"
          );
          // const filteredProductCategory = objList.productCategories.filter((items) => items.text === "Investment Instrument")

          objList?.productCategories.forEach((elements) => {
            tempProductCategory.push({
              value: elements.value,
              label: elements.text,
            });
          });

          filteredInterestTypes.forEach((elements) => {
            tempInterestTypes.push({
              value: elements.value,
              label: elements.text,
            });
          });

          objList?.assetGLAccounts?.forEach((element) => {
            tempAssetGlAccounts.push({
              value: element.id,
              label: `${element.glCode}-(${element.name})`,
              currency: element.currencyCode,
            });
          });

          objList?.incomeGlAccounts?.forEach((element) => {
            tempIncomeGlAccounts.push({
              value: element.id,
              label: `${element.glCode}-(${element.name})`,
              currency: element.currencyCode,
            });
          });

          setInterestTypeOptions(tempInterestTypes);
          setAssetAccountOptions(tempAssetGlAccounts);
          setIncomeAccountOptions(tempIncomeGlAccounts);
          setProductCategoryOptions(tempProductCategory);

          // form.setFieldsValue({
          //   currencyCode: objList?.currencies?.find(
          //     (item) => item.code === "NGN"
          //   ).code,
          // });

          setLoading(false);
        }
      },
      "treasury"
    );
  };

  const filteredAssetAccounts = assetAccountOptions.filter(
    (item) => item.currency === currency
  );

  const filteredIncomeAccounts = incomeAccountOptions.filter(
    (item) => item.currency === currency
  );

  const getInterBankPlacementById = (params) => {
    setLoading(true);

    const url = `${apiConfig.InterBankPlacement}/${params}`;
    let body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setLoading(false);
      } else {
        setInterBankPlacementDetails(res);
        // Transform and set form values
        // const formValues = transformBackendData(res);
        // form.setFieldsValue(formValues);

        form.setFieldsValue({
          // Product Information
          productCode: res?.productCode ?? "",
          productName: res?.productName,
          productCategory: res?.productCategory?.value,
          currencyCode: res?.currencyCode,
          applicableEntities: res?.applicableEntities?.map(
            (entity) => entity.id
          ),
          custodian: res?.custodian?.id,
          accountingClassification: res?.accountingClassification?.id,
          startDate: res?.startDate
            ? dayjs(BOM.FormatArrayDate(res?.startDate))
            : null,
          endDate: res?.endDate
            ? dayjs(BOM.FormatArrayDate(res?.endDate))
            : null,

          // Terms Configuration
          minTenor: res?.minTenor,
          maxTenor: res?.maxTenor,
          defaultTenor: res?.defaultTenor,
          maturityDateAdjustment: res?.maturityDateAdjustment?.value,
          allowRollover: res?.allowRollover,
          backDatedValueDateAllowed: res?.backDatedValueDateAllowed,
          allowEarlyTermination: res?.allowEarlyTermination,
          allowPlacementFee: res?.allowPlacementFee,
          autoRollover: res?.autoRollover,
          earlyTerminationWithPenalty: res?.earlyTerminationWithPenalty,
          placementFeeWithPenalty: res?.placementFeeWithPenalty,
          penaltyCharge: res?.penaltyCharge?.id ? res?.penaltyCharge?.id : null,
          redemptionCharge: res?.redemptionCharge?.id
            ? res?.redemptionCharge?.id
            : null,

          // Interest Configuration
          interestType: res?.interestType?.value,
          interestRateType: res?.interestRateType?.value,
          defaultRate: res?.defaultRate,
          interestCalculationBasis: res?.interestCalculationBasis?.value,
          interestPostingType: res?.interestPostingType?.value,
          allowTax: res?.allowTax,
          taxGroup: res?.taxGroup?.id,

          // Accounting Configuration
          placementInitiationDebit: res?.investmentGL?.debitAccount?.id,
          placementInitiationCredit: res?.investmentGL?.creditAccount?.id,
          interestAccrualDebit: res?.accruedInterestGL?.debitAccount?.id,
          interestAccrualCredit: res?.accruedInterestGL?.creditAccount?.id,
          interestSettlementDebit: res?.settlementGL?.debitAccount?.id,
          interestSettlementCredit: res?.settlementGL?.creditAccount?.id,
          principalRedemptionDebit: res?.principalGL?.debitAccount?.id,
          principalRedemptionCredit: res?.principalGL?.creditAccount?.id,
          interestGLPostingDebit: res?.interestIncomeGL?.debitAccount?.id,
          interestGLPostingCredit: res?.interestIncomeGL?.creditAccount?.id,

          // Counterparty Settings
          counterpartyTypes: res?.counterpartyTypes?.map((type) => type.id),
          kycRequirements: res?.kycRequirements[0]?.id,
          activateDealConfirmation: res?.activateDealConfirmation,
          allowSwiftCode: res?.allowSwiftCode,
          allowRTGS: res?.allowRTGS,

          // Compliance Settings
          centralBankReports: res?.centralBankReports?.map(
            (report) => report.id
          ),
          riskLimit: res?.riskLimit?.toString(),
          mandatoryAMLScreening: res?.mandatoryAMLScreening,
        });

        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getInterbankTemplate();
    if (selectedInterBankPlacementKey) {
      getInterBankPlacementById(selectedInterBankPlacementKey);
    }
  }, [selectedInterBankPlacementKey]);

  const handleNext = () => {
    const nextTab = String(Number(activeTab) + 1);
    setActiveTab(nextTab);
  };

  const handlePrevious = () => {
    const previousTab = String(Number(activeTab) - 1);
    setActiveTab(previousTab);
  };

  const handleClose = () => {
    setShowSuccessModal(false);
  };

  const handleNavigateToManage = () => {
    navigate("/interbank-placement");
    handleClose();
  };

  const handleUpdateProduct = () => {
    const formValues = form.getFieldsValue(true);

    setIsUpdatingProduct(true);

    // delete formValues.placementFeeWithPenalty;
    // delete formValues.earlyTerminationPenaltyCharge;
    // delete formValues.earlyTerminationWithPenalty;
    // delete formValues.placementFeePenaltyCharge;

    let body = {
      method: "PUT",
      session: userData.session,
      ...Object.fromEntries(
        Object.entries(formValues).filter(
          ([key]) =>
            key !== "startDate" &&
            key !== "endDate" &&
            key !== "backDatedValueDateAllowed" &&
            key !== "placementInitiationDebit" &&
            key !== "placementInitiationCredit" &&
            key !== "interestAccrualDebit" &&
            key !== "interestAccrualCredit" &&
            key !== "interestSettlementDebit" &&
            key !== "interestSettlementCredit" &&
            key !== "principalRedemptionDebit" &&
            key !== "principalRedemptionCredit" &&
            key !== "interestGLPostingDebit" &&
            key !== "interestGLPostingCredit" &&
            key !== "minTenor" &&
            key !== "maxTenor" &&
            key !== "riskLimit" &&
            key !== "defaultTenor" &&
            key !== "defaultRate" &&
            key !== "taxGroup" &&
            key !== "kycRequirements"
        )
      ),
      // redemptionCharge: formValues.earlyTerminationPenaltyCharge,
      // penaltyCharge: formValues.placementFeePenaltyCharge,
      backDatedValueDateAllowed: formValues.backDatedValueDateAllowed,
      allowTax: formValues.allowTax,
      taxGroup: formValues.taxGroup,
      kycRequirements: formValues.kycRequirements
        ? Array.isArray(formValues.kycRequirements)
          ? formValues.kycRequirements
          : [formValues.kycRequirements]
        : [],
      minTenor: Number(formValues.minTenor),
      maxTenor: Number(formValues.maxTenor),
      defaultTenor: Number(formValues.defaultTenor),
      defaultRate: Number(formValues.defaultRate),
      riskLimit: Number(formValues.riskLimit),
      investmentGL: [
        formValues.placementInitiationDebit,
        formValues.placementInitiationCredit,
      ],
      accruedInterestGL: [
        formValues.interestAccrualDebit,
        formValues.interestAccrualCredit,
      ],
      settlementGL: [
        formValues.interestSettlementDebit,
        formValues.interestSettlementCredit,
      ],
      principalGL: [
        formValues.principalRedemptionDebit,
        formValues.principalRedemptionCredit,
      ],
      interestIncomeGL: [
        formValues.interestGLPostingDebit,
        formValues.interestGLPostingCredit,
      ],
      startDate: BOM.DateTime(formValues.startDate, "only-date"),
      endDate: BOM.DateTime(formValues.endDate, "only-date"),
      dateFormat: "dd MMMM yyyy",
      locale: "en",
    };

    const url = `${apiConfig.InterBankPlacement}/${selectedInterBankPlacementKey}`;

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          setIsUpdatingProduct(false);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          setIsUpdatingProduct(false);
          setShowSuccessModal(true);
        }
      },
      "treasury"
    );
  };

  const tabItems = [
    {
      key: "1",
      label: (
        <TabLabel
          number="1"
          label="Product Information"
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 1}
        />
      ),
      children: (
        <ProductInformationContent
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          interbankTemplate={interbankTemplate}
          onCurrencyChange={setCurrency}
        />
      ),
    },
    {
      key: "2",
      label: (
        <TabLabel
          number="2"
          label="Terms"
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 2}
        />
      ),
      children: (
        <TermsContent
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          interbankTemplate={interbankTemplate}
        />
      ),
    },
    {
      key: "3",
      label: (
        <TabLabel
          number="3"
          label="Interest"
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 3}
        />
      ),
      children: (
        <InterestContent
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          interbankTemplate={interbankTemplate}
          interestTypeOptions={interestTypeOptions}
        />
      ),
    },
    {
      key: "4",
      label: (
        <TabLabel
          number="4"
          label="Accounting"
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 4}
        />
      ),
      children: (
        // <AccountingContent
        //   form={form}
        //   onNext={handleNext}
        //   onPrevious={handlePrevious}
        //   interbankTemplate={interbankTemplate}
        // />
        <AccountingContent
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          interbankTemplate={interbankTemplate}
          assetAccountOptions={filteredAssetAccounts}
          incomeAccountOptions={filteredIncomeAccounts}
        />
      ),
    },
    {
      key: "5",
      label: (
        <TabLabel
          number="5"
          label="Counterparty Settings"
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 5}
          interbankTemplate={interbankTemplate}
        />
      ),
      children: (
        <CounterpartySettingsContent
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          interbankTemplate={interbankTemplate}
        />
      ),
    },
    {
      key: "6",
      label: (
        <TabLabel
          number="6"
          label="Compliance"
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 6}
        />
      ),
      children: (
        <ComplianceContent
          form={form}
          onNext={handleNext}
          onPrevious={handlePrevious}
          interbankTemplate={interbankTemplate}
          currency={currency}
        />
      ),
    },
    {
      key: "7",
      label: (
        <TabLabel
          number="7"
          label="Preview"
          isLast={true}
          activeTab={activeTab}
          isCompleted={Number(activeTab) > 7}
        />
      ),
      children: (
        // <PreviewContent
        //   form={form}
        //   onPrevious={handlePrevious}
        //   onUpdateProduct={handleUpdateProduct}
        //   isUpdatingProduct={isUpdatingProduct}
        // />
        <Preview
          form={form}
          onPrevious={handlePrevious}
          onCreateProduct={handleUpdateProduct}
          isCreatingProduct={isUpdatingProduct}
          interbankTemplate={interbankTemplate}
          interestTypeOptions={interestTypeOptions}
          assetAccountOptions={filteredAssetAccounts}
          incomeAccountOptions={filteredIncomeAccounts}
          isCreateButton={isCreateButton}
        />
      ),
    },
  ];

  return (
    <MainLayout pageItems={staticConfig.createInterBankPlacement}>
      <div className="create-interbank-placement">
        <TopContent
          pageTitle={labelConfig.manageInterBankPlacement}
          createPageTitle={"Edit Product ..."}
        />
        <Spin spinning={loading} size="large">
          <div style={{ padding: "24px" }}>
            <Tabs
              activeKey={activeTab}
              onChange={handleNext}
              tabPosition="left"
              items={tabItems}
              style={{ minHeight: "723px" }}
              tabBarStyle={{
                width: "288px",
                borderRight: "none",
                pointerEvents: "none",
              }}
              className="vertical-numbered-tabs"
            />
          </div>
        </Spin>
      </div>

      {/* Success Modal */}
      <FeedbackModal
        visible={showSuccessModal}
        type="success"
        message="Your Interbank Placement Product has been updated successfully."
        // onPrimaryAction={handleClose}
        onSecondaryAction={handleNavigateToManage}
        onClose={handleClose}
      />
    </MainLayout>
  );
};

// Updated scoped styles
const styles = `
  .create-interbank-placement {
    /* Tabs styling */
    .vertical-numbered-tabs {
      .ant-tabs-tab {
        padding: 24px !important;
        margin: 0 !important;
        transition: all 0.3s;
        
        &:not(:first-child) {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
        
        &:hover {
          background: transparent;
        }
        
        &.ant-tabs-tab-active {
          background: transparent;
        }
      }
      
      .ant-tabs-content {
        padding-left: 24px;
        border-left: none;
      }

      .ant-tabs-content-holder {
        border-left: none;
      }
      
      .ant-tabs-nav::before {
        display: none !important;
      }
      
      .ant-tabs-ink-bar {
        display: none;
      }

      .ant-tabs-nav-list {
        border-right: none !important;
      }
    }

    /* Form styling */
    .ant-form {
      .ant-form-item-required::before {
        display: none !important;
      }

      .ant-form-item-label > label {
        height: 20px;
        color: #344054;
        font-size: 14px;
        font-weight: 500;
      }
    }

    /* Input styling */
    .ant-input {
      padding: 10px 14px;
    }

    .ant-input-affix-wrapper {
      height: 0px 11px !important;
    }

    .ant-input-outlined:focus-within,
    .ant-input-outlined:hover {
      border-color: #F6D0FE;
      box-shadow: 0 0 0 4px rgba(246, 208, 254, 0.4);
    }
      

    /* DatePicker styling */
    .ant-picker {
      padding: 10px 14px;
      
      .ant-picker-input > input {
        height: 24px;
        line-height: 24px;
        margin: 0px !important;
      }

      &:focus-within,
      &:hover {
        border-color: #F6D0FE;
        box-shadow: 0 0 0 4px rgba(246, 208, 254, 0.4);
      }
    }

    /* Select styling */
    .ant-select:not(.ant-select-multiple) {
      .ant-select-selector {
        height: 44px !important;
        padding: 0 11px !important;
        
        .ant-select-selection-placeholder {
          line-height: 44px !important;
        }

        .ant-select-selection-item {
          line-height: 42px !important;
        }
      }
    }

    /* Multi-select specific styling */
    .ant-select-multiple {
      .ant-select-selector {
        padding: 4px 11px !important;
        min-height: 44px !important;
        height: auto !important;
        background: #FFFFFF !important;
        border: 1px solid #D0D5DD !important;
        border-radius: 8px !important;
        
        .ant-select-selection-item {
          height: 24px !important;
          line-height: 22px !important;
          margin: 2px 4px !important;
          padding: 0 8px !important;
          background: #F9FAFB !important;
          border: 1px solid #EAECF0 !important;
          border-radius: 6px !important;
          color: #344054 !important;
        }

        .ant-select-selection-placeholder {
          line-height: 36px !important;
          color: #667085 !important;
        }

        .ant-select-selection-search {
          margin: 0 !important;
          padding: 0 !important;
          height: 32px !important;
          line-height: 32px !important;
          
          input {
            height: 32px !important;
          }
        }
      }
    &:focus-within,
      &:hover {
        .ant-select-selector {
          border-color: #F6D0FE !important;
          box-shadow: 0 0 0 4px rgba(246, 208, 254, 0.4) !important;
        }
      }
    }

    /* Custom dropdown styles */
    .custom-select-dropdown {
      padding: 8px !important;
      background: #FFFFFF !important;
      border: 1px solid #EAECF0 !important;
      box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08) !important;
      border-radius: 8px !important;

      .ant-select-item {
        padding: 10px 12px !important;
        border-radius: 6px !important;
        margin: 1px 0 !important;
        
        &:hover {
          background: #F9FAFB !important;
        }

        .ant-checkbox {
          margin-right: 12px !important;
          top: 0 !important;

          .ant-checkbox-inner {
            border-color: #D0D5DD !important;
            border-radius: 4px !important;
          }
        }

        &.ant-select-item-option-selected {
          background: #F9FAFB !important;
          font-weight: 400 !important;
          
          .ant-checkbox-checked .ant-checkbox-inner {
            background-color: #9F1AB1 !important;
            border-color: #9F1AB1 !important;
          }
        }
      }
    }

    /* Switch styles */
    .ant-switch {
      background-color: #f2f4f7 !important;
    }

    .ant-switch-checked {
      background-color: #9F1AB1 !important;
    }

    /* Common select focus/hover styles */
    .ant-select {
      &:focus-within,
      &:hover {
        .ant-select-selector {
          border-color: #F6D0FE !important;
          box-shadow: 0 0 0 4px rgba(246, 208, 254, 0.1) !important;
        }
      }

      &.ant-select-focused {
        .ant-select-selector {
          border-color: #F6D0FE !important;
          box-shadow: 0 0 0 4px rgba(246, 208, 254, 0.1) !important;
        }
      }
    }
  }
`;

// Add style tag to document head
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction, getGlListAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInterBankPlacement);
